import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nurseryPage: 1,
  waterPage: 1,
  harvestPage: 1,
  cropPage: 1,
  farmerOrderPage: 1,
  cnfOrderPage: 1,
  priceWatcherPage: 1,
  priceScrapperPage: 1,
  purchaseOrderPage: 1,
  serviceOrderPage: 1,
  purchaseVendorManagementPage: 1,
  materialListPage: 1,
  materialInventoryPage: 1,
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setNurseryPage: (state, action) => {
      state.nurseryPage = action.payload;
    },
    setWaterPage: (state, action) => {
      state.waterPage = action.payload;
    },
    setHarvestPage: (state, action) => {
      state.harvestPage = action.payload;
    },
    setCropPage: (state, action) => {
      state.cropPage = action.payload;
    },
    setFarmerOrderPage: (state, action) => {
      state.farmerOrderPage = action.payload;
    },
    setCnfOrderPage: (state, action) => {
      state.cnfOrderPage = action.payload;
    },
    setPriceWatcherPage: (state, action) => {
      state.priceWatcherPage = action.payload;
    },
    setPriceScrapperPage: (state, action) => {
      state.priceScrapperPage = action.payload;
    },
    setPurchaseOrderPage: (state, action) => {
      state.purchaseOrderPage = action.payload;
    },
    setServiceOrderPage: (state, action) => {
      state.serviceOrderPage = action.payload;
    },
    setPurchaseVendorManagementPage: (state, action) => {
      state.purchaseVendorManagementPage = action.payload;
    },
    setMaterialListPage: (state, action) => {
      state.materialListPage = action.payload;
    },
    setMaterialInventoryPage: (state, action) => {
      state.materialInventoryPage = action.payload;
    },
  },
});

export const {
  setMaterialInventoryPage,
  setMaterialListPage,
  setPurchaseVendorManagementPage,
  setPurchaseOrderPage,
  setServiceOrderPage,
  setPriceScrapperPage,
  setPriceWatcherPage,
  setCnfOrderPage,

  setNurseryPage,
  setWaterPage,
  setHarvestPage,
  setCropPage,
  setFarmerOrderPage,
} = paginationSlice.actions;
export default paginationSlice.reducer;
